import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { INVENTORIES_READ } from '~/components/routes/inventories/permissions'
import { StoreInventoryModal } from '~/components/routes/inventories/store-inventory-modal'
import { withRoutePermissions } from '~/utils/rbac'

/** La modale d'une boutique — route enfant pour garder l'URL partageable (spec v2 §4.3). */
export const Route = createFileRoute('/_authenticated/inventories/$storeId')({
  staticData: { permission: INVENTORIES_READ },
  component: RouteComponent,
  params: {
    parse: z.object({ storeId: z.coerce.number().int().positive() }).parse,
  },
})
withRoutePermissions(Route)

function RouteComponent() {
  const { storeId } = Route.useParams()

  return <StoreInventoryModal storeId={storeId} />
}
